import { render, staticRenderFns } from "./cuDiabetesTeam.vue?vue&type=template&id=51aed349&scoped=true"
import script from "./cuDiabetesTeam.vue?vue&type=script&lang=js"
export * from "./cuDiabetesTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51aed349",
  null
  
)

export default component.exports